module.exports = __webpack_public_path__ + "static/media/sappa_background.20acdae4.jpg";